import React from 'react';
import { Button } from '@ditioas/web-ui';
import { Link } from 'react-router';

import FullscreenMessageWrapper from 'components/fullscreen-message-wrapper';

interface NotFoundProps {
  heading: string;
  description: string;
  actionButtonText: string;
  actionButtonLink: string;
}

const NotFound = ({
  heading,
  description,
  actionButtonText,
  actionButtonLink,
}: NotFoundProps) => {
  const isExternalLink =
    actionButtonLink.startsWith('https://') ||
    actionButtonLink.startsWith('http://');

  return (
    <FullscreenMessageWrapper>
      <p className="body-lg">404</p>
      <h2 className="heading-lg">{heading}</h2>
      <p className="body-sm">{description}</p>
      {isExternalLink ? (
        <Button data-testid="not-found.link-button" asChild>
          <a href={actionButtonLink}>{actionButtonText}</a>
        </Button>
      ) : (
        <Button data-testid="not-found.action" asChild>
          <Link to={actionButtonLink}>{actionButtonText}</Link>
        </Button>
      )}
    </FullscreenMessageWrapper>
  );
};

export default NotFound;
